/* Statement Jewelers redesign: small behaviours for .sj sections. */
(function () {
  function initQuotes(root) {
    if (root.dataset.sjReady) return;
    root.dataset.sjReady = '1';
    var quotes = root.querySelectorAll('.sj-quote');
    var dots = root.querySelectorAll('.sj-dot');
    if (quotes.length < 2) return;
    var i = 0, timer;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function show(n) {
      i = (n + quotes.length) % quotes.length;
      quotes.forEach(function (q, k) { q.classList.toggle('is--active', k === i); q.setAttribute('aria-hidden', k !== i); });
      dots.forEach(function (d, k) { d.classList.toggle('is--active', k === i); d.setAttribute('aria-current', k === i); });
    }
    function play() { if (!reduce) { clearInterval(timer); timer = setInterval(function () { show(i + 1); }, 7000); } }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); play(); }); });
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', play);
    play();
  }

  /* Article: table of contents from h2s, active section, copy link */
  function initArticle(scope) {
    var prose = (scope || document).querySelector('[data-sj-prose]');
    var toc = (scope || document).querySelector('[data-sj-toc]');
    if (!prose || !toc || toc.dataset.sjReady) return;
    toc.dataset.sjReady = '1';
    /* Lede = first paragraph with text. Hide broken inline images, and a first image that repeats the featured photo. */
    var lede = [].find.call(prose.querySelectorAll(':scope > p'), function (p) { return p.textContent.trim().length > 0 && !p.querySelector('img'); });
    if (lede) lede.classList.add('sj-lede');
    var featured = document.querySelector('.sj-art-figure img');
    var stem = function (u) { return (u || '').split('/').pop().split('?')[0].replace(/_[0-9a-f-]{36}/, '').replace(/\.(webp|jpe?g|png)$/, ''); };
    prose.querySelectorAll('img').forEach(function (img, k) {
      var box = img.closest('figure, p, span') || img;
      var hide = function () { box.style.display = 'none'; };
      if (k === 0 && featured && stem(img.src) === stem(featured.currentSrc || featured.src)) hide();
      if (img.complete && img.naturalWidth === 0) hide(); else img.addEventListener('error', hide);
    });
    var heads = [].filter.call(prose.querySelectorAll('h2'), function (h) { if (h.textContent.trim()) return true; h.style.display = 'none'; return false; });
    if (heads.length >= 2) {
      heads.forEach(function (h, k) {
        if (!h.id) h.id = 'sj-' + (h.textContent || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 'section-' + k;
        var li = document.createElement('li'), a = document.createElement('a');
        a.href = '#' + h.id; a.textContent = h.textContent; li.appendChild(a); toc.appendChild(li);
      });
      toc.hidden = false;
      var label = document.querySelector('[data-sj-toc-label]'); if (label) label.hidden = false;
      var links = toc.querySelectorAll('a');
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) links.forEach(function (l) { l.classList.toggle('is--active', l.getAttribute('href') === '#' + e.target.id); });
          });
        }, { rootMargin: '0px 0px -70% 0px' });
        heads.forEach(function (h) { io.observe(h); });
      }
    }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sj-copy]');
    if (!b) return;
    navigator.clipboard && navigator.clipboard.writeText(b.dataset.sjCopy).then(function () { var t = b.textContent; b.textContent = '✓'; setTimeout(function () { b.textContent = t; }, 1500); });
  });

  /* Collection toolbar: sort submits on change; only one filter dropdown open at a time */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-sj-autosubmit]')) e.target.form.submit();
  });
  document.addEventListener('toggle', function (e) {
    if (e.target.matches && e.target.matches('[data-sj-dd]') && e.target.open)
      document.querySelectorAll('[data-sj-dd][open]').forEach(function (d) { if (d !== e.target) d.open = false; });
  }, true);
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-sj-dd]')) document.querySelectorAll('[data-sj-dd][open]').forEach(function (d) { d.open = false; });
  });

  /* Diamond search tool tabs: swap iframes, load each one on first view */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-sj-dtab]');
    if (!t) return;
    var root = t.closest('[data-sj-dtool]'), i = t.dataset.sjDtab;
    root.querySelectorAll('[data-sj-dtab]').forEach(function (b) { var on = b === t; b.classList.toggle('is--active', on); b.setAttribute('aria-selected', on); });
    root.querySelectorAll('[data-sj-dframe]').forEach(function (f) {
      var on = f.dataset.sjDframe === i; f.classList.toggle('is--active', on);
      var fr = f.querySelector('iframe[data-src]'); if (on && fr) { fr.src = fr.dataset.src; fr.removeAttribute('data-src'); }
    });
  });

  /* Product page: gallery, variant picker, recommendations */
  function money(cents, fmt) {
    var n = (cents / 100), parts;
    function fx(d, sep, dec) { parts = n.toFixed(d).split('.'); return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep) + (parts[1] ? dec + parts[1] : ''); }
    return (fmt || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return fx(0, ',', '.');
      if (k === 'amount_with_comma_separator') return fx(2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return fx(0, '.', ',');
      return fx(2, ',', '.');
    });
  }
  function initGallery(g) {
    if (g.dataset.sjReady) return; g.dataset.sjReady = 1;
    var slides = [].slice.call(g.querySelectorAll('[data-sj-slide]')), thumbs = [].slice.call(g.querySelectorAll('[data-sj-thumb]'));
    var track = g.querySelector('[data-sj-gallery-track]'), idx = g.querySelector('[data-sj-gallery-index]');
    function show(id, scroll) {
      var k = 0;
      slides.forEach(function (sl, j) { var on = sl.dataset.mediaId === String(id); sl.classList.toggle('is--active', on); if (on) k = j; });
      thumbs.forEach(function (t) { t.classList.toggle('is--active', t.dataset.sjThumb === String(id)); });
      if (idx) idx.textContent = k + 1;
      if (scroll && track.scrollWidth > track.clientWidth + 4) track.scrollTo({ left: slides[k].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    g._sjShow = show;
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t.dataset.sjThumb, true); }); });
    var tick;
    track.addEventListener('scroll', function () {
      clearTimeout(tick);
      tick = setTimeout(function () {
        if (track.scrollWidth <= track.clientWidth + 4) return;
        var k = Math.round(track.scrollLeft / track.clientWidth), sl = slides[k];
        if (sl) { if (idx) idx.textContent = k + 1; thumbs.forEach(function (t) { t.classList.toggle('is--active', t.dataset.sjThumb === sl.dataset.mediaId); }); }
      }, 80);
    }, { passive: true });
  }
  function initProduct(root) {
    if (root.dataset.sjReady) return; root.dataset.sjReady = 1;
    var g = root.querySelector('[data-sj-gallery]'); if (g) initGallery(g);
    var dataEl = root.querySelector('[data-sj-product-json]'), opts = root.querySelector('[data-sj-options]');
    if (!dataEl || !opts) return;
    var data = JSON.parse(dataEl.textContent);
    opts.addEventListener('change', function () {
      var chosen = [].map.call(opts.querySelectorAll('fieldset'), function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
      chosen.forEach(function (v, k) { var l = opts.querySelector('[data-sj-opt-value="' + k + '"]'); if (l) l.textContent = v; });
      var v = data.variants.find(function (x) { return x.options.every(function (o, k) { return o === chosen[k]; }); });
      var idIn = root.querySelector('[data-sj-variant-id]'), btn = root.querySelector('[data-sj-atc]'), txt = root.querySelector('[data-sj-atc-text]');
      var price = root.querySelector('[data-sj-price]'), cmp = root.querySelector('[data-sj-compare]'), sku = root.querySelector('[data-sj-sku]');
      if (!v) { if (btn) { btn.disabled = true; btn.setAttribute('aria-disabled', 'true'); } if (txt) txt.textContent = data.unavailableText; return; }
      if (idIn) idIn.value = v.id;
      if (btn) { btn.disabled = !v.available; if (v.available) btn.removeAttribute('aria-disabled'); else btn.setAttribute('aria-disabled', 'true'); }
      if (txt) txt.textContent = v.available ? data.addText : data.soldText;
      if (price) price.textContent = v.price === 0 ? 'Price on Request' : money(v.price, data.moneyFormat);
      if (cmp) { var on = v.compare_at_price > v.price; cmp.hidden = !on; if (on) cmp.textContent = money(v.compare_at_price, data.moneyFormat); }
      if (sku) { sku.hidden = !v.sku; sku.textContent = 'Ref. ' + (v.sku || ''); }
      if (v.featured_media && g && g._sjShow) g._sjShow(v.featured_media.id, true);
      if (history.replaceState) history.replaceState({}, '', data.url + '?variant=' + v.id);
    });
  }
  function initRecs(el) {
    if (el.dataset.sjReady || !el.dataset.url) return; el.dataset.sjReady = 1;
    var go = function () {
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var d = document.createElement('div'); d.innerHTML = html;
        var fresh = d.querySelector('[data-sj-recs]');
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; el.classList.add('is--loaded'); } else { el.hidden = true; }
      }).catch(function () { el.hidden = true; });
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); go(); } }, { rootMargin: '600px' });
      io.observe(el);
    } else go();
  }
  function init(scope) {
    var sc = scope || document;
    sc.querySelectorAll('[data-sj-product]').forEach(initProduct);
    sc.querySelectorAll('[data-sj-recs]').forEach(initRecs);
    initArticle(scope); (scope || document).querySelectorAll('[data-sj-quotes]').forEach(initQuotes); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
